import httpUtil from "../assets/script/utils/http";
// import config from '../assets/script/config'

const state = {};

const mutations = {};

//
const actions = {
  //素材里的文章列表
  AActicle(ctx, params) {
    return httpUtil.post("/ai/acticle", params);
  },
  //文章详情
  AActicledetail(ctx, params) {
    return httpUtil.post("/ai/acticledetail", params);
  },
  //根据关键词获取平台
  APlatform(ctx, params) {
    return httpUtil.post("/ai/Platform", params);
  },
  //收藏文章
  AFavoriteArticle(ctx, params) {
    return httpUtil.post("/ai/FavoriteArticle", params);
  },
  //段落
  AParagraph(ctx, params) {
    return httpUtil.post("/ai/paragraph", params);
  },
  //段落原文
  AParagraphResource(ctx, params) {
    return httpUtil.post("/ai/ParagraphResource", params);
  },
  //收藏段落
  AFavoriteParagraph(ctx, params) {
    return httpUtil.post("/ai/FavoriteParagraph", params);
  },
  //长尾词
  ALongWord(ctx, params) {
    return httpUtil.post("/ai/LongWord", params);
  },
  //图片列表
  AImages(ctx, params) {
    return httpUtil.post("/ai/images", params);
  },
  //收藏图片
  AFavoritePicture(ctx, params) {
    return httpUtil.post("/ai/FavoritePicture", params);
  },
  //回收站
  ARecycle(ctx, params) {
    return httpUtil.post("/ai/Recycle", params);
  },
  //文集列表
  ADoc(ctx, params) {
    return httpUtil.post("/ai/doc", params);
  },
  //文集置顶
  ADocSetTop(ctx, params) {
    return httpUtil.post("/ai/DocSetTop", params);
  },
  //doc删除
  ADocDel(ctx, params) {
    return httpUtil.post("/ai/docdel", params);
  },
  //文集详情
  ADocDetail(ctx, params) {
    return httpUtil.post("/ai/DocDetail", params);
  },
  //文件夹
  AFolder(ctx, params) {
    return httpUtil.post("/ai/folder", params);
  },
  //文件夹 string docIdList, int oldFolderId, int newFolderId
  ADocMove(ctx, params) {
    return httpUtil.post("/ai/docmove", params);
  },
  //文集撤回DocIdList
  ADocRecovery(ctx, params) {
    return httpUtil.post("/ai/docrecovery", params);
  },
  //删除文件夹
  AFolderDel(ctx, params) {
    return httpUtil.post("/ai/folderdel", params);
  },
  //创建文件夹
  AFolderCreate(ctx, params) {
    return httpUtil.post("/ai/foldercreate", params);
  },
  APermission(ctx, params) {
    return httpUtil.post("/ai/permission", params);
  },
  //分词接口
  AFenci(ctx, params) {
    return httpUtil.post("/wordcloud/fenci", params);
  },
  //采集进度
  AGatherPercent(ctx, params) {
    return httpUtil.post("/ai/GatherPercent", params);
  },
  //用户信息
  Auserinfo(ctx, params) {
    return httpUtil.post("/ai/userinfo", params);
  },
  //插入智能段落任务
  AParagraphTask(ctx, params) {
    return httpUtil.post("/ai/ParagraphTask", params);
  },
  //获取智能段落进度
  AParagraphProgress(ctx, params) {
    return httpUtil.post("/ai/ParagraphProgress", params);
  },
  //链接导入文章
  ALink(ctx, params) {
    return httpUtil.post("/import/link", params);
  },
  //新数据
  ANewCount(ctx, params) {
    return httpUtil.post("/ai/newcount", params);
  },
  //图片新数据
  AImageNewCount(ctx, params) {
    return httpUtil.post("/ai/imagenewcount", params);
  },
  //获取广告系统数据
  AGetAdInfo(ctx, params) {
    return httpUtil.get("/ai/getAdInfo", params);
  },
  AGetFriendship(ctx, params) {
    return httpUtil.get("/ai/Friendship", params)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
